import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Modal } from "../../../Components";
import { jobCampaignsService } from "../../../Services/jobCampaigns.service";
import Toast from "../../../Components/Base/Form/Toast";
import { ArrowLeft, Plus, RefreshCw, Sparkles } from "lucide-react";
import { SwitchWithLabel } from "../../../Components/AppSwitchWithLabel";
import { Tooltip } from "@mui/material";
import { briefService } from "../../../Services";
import CategoryMultiSelect from "../../../Components/CategoryMultiSelect";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../../../Components/ui/sidebarNew";

if (
  typeof document !== "undefined" &&
  !document.getElementById("dropdown-styles")
) {
  const styleElement = document.createElement("style");
  styleElement.id = "dropdown-styles";
  document.head.appendChild(styleElement);
}

// Helper function to get next day after a date
const getNextDay = (dateString) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() + 1);
  return date.toISOString().split("T")[0];
};

const BriefField = React.memo(
  ({
    config,
    form,
    error,
    showShareButton,
    setInput,
    fieldErrors,
    handleUseAI,
    isAILoading,
  }) => {
    const { key, label, type, isTitle, showCharCount, maxLength } = config;
    const value = form[key] || "";
    const fieldError = fieldErrors[key];
    // Get today's date in YYYY-MM-DD format for min attribute
    const getTodayDate = () => {
      const today = new Date();
      return today.toISOString().split("T")[0];
    };

    // Get min date for delivery date field
    const getDeliveryMinDate = () => {
      if (key === "delivery_date" && form?.apply_by_date) {
        return getNextDay(form?.apply_by_date);
      }
      return getTodayDate();
    };

    // Get icon for each field type
    // const getFieldIcon = () => {
    //   switch (key) {
    //     case "title":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-indigo-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M3 4a1 1 0 011-1h6a1 1 0 110 2H5v10h5a1 1 0 110 2H4a1 1 0 01-1-1V4zm10.293 5.293a1 1 0 010 1.414l-2.586 2.586a1 1 0 11-1.414-1.414L10.586 10 9.293 8.707a1 1 0 111.414-1.414l2.586 2.586z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     case "brand_profile_id":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-blue-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //           aria-hidden="true"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M10 10a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0H3z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     case "apply_by_date":
    //     case "delivery_date":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-green-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     case "platform":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-purple-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     case "category":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-orange-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
    //         </svg>
    //       );
    //     case "reach_min":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-indigo-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    //         </svg>
    //       );
    //     case "location":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-red-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     case "compensation":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-green-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
    //           <path
    //             fillRule="evenodd"
    //             d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.51-1.31c-.562-.649-1.413-1.076-2.353-1.253V5z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     case "scope_of_work":
    //     case "delivery_info":
    //     case "brief":
    //       return (
    //         <svg
    //           className="w-5 h-5 text-amber-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //     default:
    //       return (
    //         <svg
    //           className="w-5 h-5 text-gray-600"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
    //             clipRule="evenodd"
    //           />
    //         </svg>
    //       );
    //   }
    // };

    return (
      <div className="mb-2">
        <div>
          <div className="space-y-1">
            {/* {!isTitle && ( */}
            <div className="flex items-center gap-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                {/* {getFieldIcon()} */}
                {label}
                {key !== "additional_info" && (
                  <span className="text-red-500">*</span>
                )}
              </label>
              {key === "additional_info" && (
                <button
                  type="button"
                  className="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-emerald-600 bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-200/60 rounded-lg hover:shadow-md hover:shadow-emerald-100/50 hover:border-emerald-300/80 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                  onClick={handleUseAI}
                  disabled={isAILoading}
                >
                  {isAILoading ? (
                    <div className="w-3 h-3 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <Sparkles size={12} className="animate-pulse" />
                  )}
                  <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent font-semibold">
                    {isAILoading ? "Generating..." : "Use AI"}
                  </span>
                </button>
              )}
            </div>

            {/* )} */}

            {type === "textarea" ? (
              <textarea
                value={value}
                onChange={setInput(key)}
                rows={4}
                maxLength={maxLength}
                placeholder={`Enter ${label?.toLowerCase() || "text"}...`}
                className={`w-full p-3 border rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 transition-colors resize-vertical min-h-[100px] text-gray-900 placeholder-gray-400 ${
                  fieldError ? "border-red-500 bg-red-50" : "border-gray-300"
                }`}
              />
            ) : type === "dropdown" ? (
              <div className="relative custom-dropdown">
                <select
                  value={value}
                  onChange={setInput(key)}
                  className={`w-full p-3 pr-10 border rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 transition-colors bg-white appearance-none cursor-pointer dropdown-with-scroll ${
                    fieldError ? "border-red-500 bg-red-50" : "border-gray-300"
                  } ${!value ? "text-gray-400" : "text-gray-900"}`}
                  style={{
                    backgroundImage: "none",
                    maxHeight: "200px",
                    overflowY: "auto",
                    height: "auto",
                    minHeight: "48px",
                  }}
                >
                  <option value="" disabled>
                    Select {label?.toLowerCase() || "option"}...
                  </option>
                  {config.options?.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      className="text-gray-900"
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
                {/* Custom dropdown arrow with proper positioning */}
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none z-10">
                  <svg
                    className="w-5 h-5 text-gray-400 transition-transform duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <input
                type={
                  key === "apply_by_date" || key === "delivery_date"
                    ? "date"
                    : "text"
                }
                value={value}
                onChange={setInput(key)}
                maxLength={maxLength}
                min={
                  key === "apply_by_date"
                    ? getTodayDate()
                    : key === "delivery_date"
                    ? getDeliveryMinDate()
                    : undefined
                }
                placeholder={
                  isTitle
                    ? "Enter job title..."
                    : `Enter ${label?.toLowerCase() || "text"}...`
                }
                className={`w-full p-3 border rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 transition-colors placeholder-gray-400 ${
                  fieldError ? "border-red-500 bg-red-50" : "border-gray-300"
                } ${
                  key === "apply_by_date" || key === "delivery_date"
                    ? "cursor-pointer"
                    : ""
                } ${
                  (key === "apply_by_date" || key === "delivery_date") && !value
                    ? "text-gray-400"
                    : "text-gray-900"
                }`}
                onClick={
                  key === "apply_by_date" || key === "delivery_date"
                    ? (e) => {
                        if (e.target.showPicker) {
                          e.target.showPicker();
                        } else {
                          e.target.focus();
                        }
                      }
                    : undefined
                }
              />
            )}
          </div>

          {/* {showCharCount && maxLength && (
            <div className="text-sm text-gray-500 text-right mt-0.5">
              <span
                className={
                  value.length > maxLength * 0.9 ? "text-orange-500" : ""
                }
              >
                {value.length} / {maxLength} characters
              </span>
            </div>
          )} */}

          {fieldError && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-2 mt-2">
              <div className="flex items-center gap-2">
                <svg
                  className="w-4 h-4 text-red-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                {fieldError}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

// Add display name for debugging
BriefField.displayName = "BriefField";

export default function BriefForm({
  generatedBriefResponse,
  setTab,
  setToastList,
  toastList,
  onBack,
  isEditMode,
  editCampaignData,
  refreshCampaignData,
}) {
  const createList = useRef(null);
  const { state } = useSidebar();

  // Get today's date in YYYY-MM-DD format for min attribute
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const [form, setForm] = useState({
    user_id:
      (isEditMode
        ? editCampaignData?.user_id
        : generatedBriefResponse.user_id) ?? "",
    hashtag:
      (isEditMode
        ? editCampaignData?.hashtag
        : generatedBriefResponse.hashtag) ?? "",
    title:
      (isEditMode ? editCampaignData?.title : generatedBriefResponse.title) ??
      "",
    apply_by_date:
      (isEditMode
        ? editCampaignData?.apply_by_date
        : generatedBriefResponse.apply_by_date) ?? "",
    scope_of_work:
      (isEditMode
        ? editCampaignData?.scope_of_work
        : generatedBriefResponse.scope_of_work) ?? "",
    delivery_date:
      (isEditMode
        ? editCampaignData?.delivery_date
        : generatedBriefResponse.delivery_date) ?? "",
    delivery_info:
      (isEditMode
        ? editCampaignData?.delivery_info
        : generatedBriefResponse.delivery_info) ?? "",
    compensation:
      (isEditMode
        ? editCampaignData?.compensation
        : generatedBriefResponse.compensation) ?? "",
    platform:
      (isEditMode
        ? editCampaignData?.platform
        : generatedBriefResponse.platform) ?? "",
    category:
      (isEditMode
        ? editCampaignData?.category
        : generatedBriefResponse.category) ?? [],
    reach_min:
      (isEditMode
        ? editCampaignData?.reach_min
        : generatedBriefResponse.reach_min) ?? 1000,
    location:
      (isEditMode
        ? editCampaignData?.location
        : generatedBriefResponse.location) ?? "",
    additional_info:
      (isEditMode
        ? editCampaignData?.additional_info
        : generatedBriefResponse.additional_info) ?? "",
    brand_profile_id:
      (isEditMode
        ? editCampaignData?.brand_profile_id
        : generatedBriefResponse.brand_profile_id) ?? "",
    files:
      (isEditMode ? editCampaignData?.files : generatedBriefResponse.files) ??
      [],
    ctr_url:
      (isEditMode
        ? editCampaignData?.ctr_url
        : generatedBriefResponse.ctr_url) ?? "",
  });
  console.log(
    "🚀 ~ BriefForm ~ generatedBriefResponse:",
    generatedBriefResponse
  );

  const [error, setError] = useState(true);
  const [isError, setIsError] = useState(false);

  // Field-specific validation errors
  const [fieldErrors, setFieldErrors] = useState({});
  // Upload related state
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [brandProfilesList, setBrandProfilesList] = useState([]);
  const [showList, setShowList] = useState(false);
  const [isAILoading, setIsAILoading] = useState(false);
  const [urlProtocol, setUrlProtocol] = useState("https");
  const [urlInput, setUrlInput] = useState("");

  // Should match the new fieldConfigs keys:
  const [readOnlyFields, setReadOnlyFields] = useState({
    title: true,
    apply_by_date: true,
    scope_of_work: true,
    delivery_date: true,
    delivery_info: true,
    compensation: true,
    platform: true,
    category: true,
    reach_min: true,
    location: true,
    additional_info: true,
  });
  console.log("🚀 ~ BriefForm ~ readOnlyFields:", readOnlyFields);
  const [showShareButton, setShowShareButton] = useState(false);
  const [newGalleryUploaded, setNewGalleryUploaded] = useState(
    generatedBriefResponse.files ?? []
  );
  const [indexForAction, setIndexForAction] = useState(0);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [sociaMediaList, setSociaMediaList] = useState();
  const [categoriesList, setCategoriesList] = useState();
  const [countryList, setCountrytList] = useState();
  const navigate = useNavigate();

  const handleUseAI = async () => {
    try {
      // Validate required fields
      if (
        !form.title ||
        !form.hashtag ||
        !form.apply_by_date ||
        !form.delivery_date ||
        !form.compensation ||
        !form.platform ||
        !form.category?.length ||
        !form.reach_min ||
        !form.location
      ) {
        addToast({
          error: true,
          msg: "Complete all fields for a better AI-generated brief.",
        });
        return;
      }

      setIsAILoading(true);

      const fields = [
        { label: "Title", value: form.title },
        { label: "Hashtag", value: form.hashtag },
        { label: "Apply By", value: form.apply_by_date },
        { label: "Delivery Date", value: form.delivery_date },
        { label: "Compensation", value: form.compensation },
        { label: "Platform", value: form.platform },
        {
          label: "Category",
          value: form.category?.map((c) => c.name).join(", "),
        },
        { label: "Reach Min", value: form.reach_min },
        { label: "Location", value: form.location },
      ];

      const description = fields
        .filter((field) => field.value)
        .map((field) => `${field.label}: ${field.value}`)
        .join("\n");

      const payload = {
        description,
      };
      console.log("🚀 ~ handleUseAI ~ payload:", payload);

      const res = await briefService.generateBrief(payload);
      console.log("🚀 ~ handleUseAI ~ res:", res);

      if (res && res.success) {
        if (res.data?.brief_summary) {
          updateForm({ additional_info: res.data?.brief_summary });
        }
      } else {
        addToast({
          error: true,
          msg: res.message || "Failed to generate AI content",
        });
      }
    } catch (error) {
      console.error("AI generation error:", error);
      addToast({
        error: true,
        msg: error.message || "Error generating AI content",
      });
    } finally {
      setIsAILoading(false);
    }
  };

  // Field configuration - wrapped in useMemo to prevent recreation on each render
  const fieldConfigs = useMemo(
    () => [
      {
        key: "hashtag",
        label: "Hashtag",
        type: "input",
        // isTitle: true,
        showCharCount: true,
        maxLength: 100,
      },
      {
        key: "title",
        label: "Job Title",
        type: "input",
        isTitle: true,
        showCharCount: true,
        maxLength: 100,
      },

      {
        key: "apply_by_date",
        label: "Apply By Date",
        type: "datePicker",
        showCharCount: false,
      },
      {
        key: "brand_profile_id",
        label: "Brand Profile",
        type: "dropdown",
        showCharCount: false,
        options: brandProfilesList,
      },
      {
        key: "platform",
        label: "Platform",
        type: "dropdown",
        showCharCount: false,
        options: sociaMediaList,
      },
      {
        key: "category",
        label: "Category",
        type: "multiselect",
        showCharCount: false,
        options: categoriesList,
      },
      {
        key: "reach_min",
        label: "Reach Minimum",
        type: "dropdown",
        showCharCount: false,
        options: [
          { value: "1000", label: "1K followers" },
          { value: "10000", label: "10K followers" },
          { value: "50000", label: "50K followers" },
          { value: "100000", label: "100K followers" },
          { value: "500000", label: "500K followers" },
          { value: "1000000", label: "1M+ followers" },
        ],
      },
      {
        key: "location",
        label: "Location",
        type: "dropdown",
        showCharCount: false,
        options: countryList,
      },
      {
        key: "scope_of_work",
        label: "Scope of Work / Responsibilities",
        type: "textarea",
        showCharCount: true,
        maxLength: 1000,
      },
      {
        key: "delivery_date",
        label: "Delivery Date",
        type: "datePicker",
        showCharCount: false,
      },
      {
        key: "delivery_info",
        label: "Delivery Information",
        type: "textarea",
        showCharCount: true,
        maxLength: 1000,
      },
      {
        key: "compensation",
        label: "Estimated Influencer Compensation",
        type: "input",
        showCharCount: true,
        maxLength: 100,
      },
      {
        key: "additional_info",
        label: "Brief",
        type: "textarea",
        showCharCount: true,
        maxLength: 1000,
      },
    ],
    [sociaMediaList, categoriesList, countryList, brandProfilesList]
  );

  const setAllFieldsReadOnly = useCallback(() => {
    setReadOnlyFields({
      title: true,
      hashtag: true,
      apply_by_date: true,
      scope_of_work: true,
      delivery_date: true,
      delivery_info: true,
      compensation: true,
      platform: true,
      category: true,
      reach_min: true,
      location: true,
      brief: true,
    });
  }, []);

  const updateForm = useCallback((data) => {
    setForm((prevForm) => {
      const newForm = { ...prevForm, ...data };
      return newForm;
    });
  }, []);

  const setInput = useCallback(
    (key) => (event) => {
      const newValue = event.target.value;
      const fieldConfig = fieldConfigs.find((config) => config.key === key);
      const maxLength = fieldConfig?.maxLength;

      // Check if maxLength is exceeded
      if (maxLength && newValue.length > maxLength) {
        setFieldErrors((prev) => ({
          ...prev,
          [key]: `Maximum ${maxLength} characters allowed. Current: ${newValue.length}`,
        }));
        return;
      } else {
        setFieldErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[key];
          return newErrors;
        });
      }

      if (key === "apply_by_date" && newValue) {
        const selectedDate = new Date(newValue);
        const today = new Date();

        // Reset time to avoid timezone issues
        today.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);

        if (selectedDate < today) {
          setFieldErrors((prev) => ({
            ...prev,
            [key]: "Apply by date cannot be in the past",
          }));
          return; // Don't update the form value
        } else {
          setFieldErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[key];
            return newErrors;
          });
        }
      }
      // Date validation
      if (key === "delivery_date" && form.apply_by_date && newValue) {
        const applyDate = new Date(form.apply_by_date);
        const deliveryDate = new Date(newValue);

        if (deliveryDate <= applyDate) {
          setFieldErrors((prev) => ({
            ...prev,
            [key]: "Delivery date must be after apply date",
          }));
        } else {
          setFieldErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[key];
            return newErrors;
          });
        }
      }

      updateForm({ [key]: newValue });
    },
    [updateForm, fieldConfigs, form.apply_by_date]
  );

  const removeItem = (indexToRemove) => {
    // Remove from gallery display
    setNewGalleryUploaded((prevItems) =>
      prevItems.filter((_, index) => index !== indexToRemove)
    );

    // Remove from form files array
    const updatedFiles = form.files.filter(
      (_, index) => index !== indexToRemove
    );
    updateForm({ files: updatedFiles });

    setShowConfirmDelete(false);
  };

  // File upload handler
  const decodeBase64Json = (encodedString) => {
    const decodedString = atob(encodedString);
    try {
      const jsonObject = JSON.parse(decodedString);
      return jsonObject;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null;
    }
  };

  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setIsUploading(true);
    setUploadError(null);

    try {
      const uploadPromises = files.map(async (file) => {
        // Validate file type
        const allowedTypes = [
          "image/gif",
          "image/png",
          "image/jpeg",
          "image/jpg",
          "video/mp4",
          "video/mov",
        ];
        if (!allowedTypes.includes(file.type)) {
          throw new Error(
            `File type ${file.type} is not allowed. Only .GIF, .PNG, .JPG, .MP4, .MOV files are supported.`
          );
        }

        // Validate file size (10MB = 10 * 1024 * 1024 bytes)
        if (file.size > 10 * 1024 * 1024) {
          throw new Error(
            `File size ${(file.size / (1024 * 1024)).toFixed(
              2
            )}MB exceeds the 10MB limit.`
          );
        }

        // Upload file
        const response = await jobCampaignsService.uploadMedia(file);

        // Handle different response formats
        let data;
        if (typeof response === "string") {
          // If response is a base64 encoded string
          const decryptedResponse = decodeBase64Json(response);
          data = JSON.parse(decryptedResponse);
        } else if (response && typeof response === "object") {
          // If response is already an object
          data = response;
        } else {
          throw new Error("Invalid response format from upload service");
        }

        return {
          file_size: data.file_size,
          file_type: data.file_type,
          original_file_name: data.original_file_name,
          mediafile: data.path || data.mediafile,
          thumbnail_path: data.thumbnail_path,
          // media_type_id: "10",
        };
      });

      const uploadedFiles = await Promise.all(uploadPromises);
      setNewGalleryUploaded((prev) => [...prev, ...uploadedFiles]);

      // Update form files array with the uploaded files
      const newFiles = [
        ...form.files,
        ...uploadedFiles.map((file) => ({
          file_size: file.file_size,
          file_type: file.file_type,
          original_file_name: file.original_file_name,
          mediafile: file.mediafile,
          thumbnail_path: file.thumbnail_path,
          media_type_id: file.media_type_id,
        })),
      ];

      updateForm({ files: newFiles });
      addToast({
        error: false,
        msg: `Successfully uploaded ${uploadedFiles.length} file${
          uploadedFiles.length > 1 ? "s" : ""
        }`,
      });
    } catch (error) {
      console.error("Upload error:", error);
      setUploadError(error.message || "Failed to upload files");
      addToast({
        error: true,
        msg: error.message || "Failed to upload files",
      });
    } finally {
      setIsUploading(false);
      event.target.value = "";
    }
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    const toastItem = { ...data, id: `${Date.now()}-${toastList.length}` };
    newToastList.push(toastItem);
    setToastList(newToastList);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        createList.current.click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [form, isError]);

  useEffect(() => {
    fetchData();
    fetchCategories();
    fetchCountries();
    fetchBrandProfiles();
  }, []);

  useEffect(() => {
    console.log("🚀 ~ BriefForm ~ editCampaignData:", editCampaignData);
    if (isEditMode && editCampaignData) {
      const transformedCategory =
        categoriesList && Array.isArray(editCampaignData.category)
          ? editCampaignData.category.map((catId) => {
              const found = categoriesList.find((c) => c.value === catId);
              return found || { value: catId, label: catId };
            })
          : editCampaignData.category || [];

      setForm({
        user_id: editCampaignData.user_id || "",
        hashtag: editCampaignData.hashtag || "",
        title: editCampaignData.title || "",
        apply_by_date: editCampaignData.apply_by_date || "",
        scope_of_work: editCampaignData.scope_of_work || "",
        delivery_date: editCampaignData.delivery_date || "",
        delivery_info: editCampaignData.delivery_info || "",
        compensation: editCampaignData.compensation || "",
        platform: editCampaignData.platform || "",
        category: transformedCategory,
        reach_min: editCampaignData.reach_min || 1000,
        location: editCampaignData.location || "",
        additional_info: editCampaignData.additional_info || "",
        brand_profile_id: editCampaignData.brand_profile_id || "",
        files: editCampaignData.files || [],
        ctr_url: editCampaignData.ctr_url || "",
      });
    }
  }, [isEditMode, editCampaignData, categoriesList]);

  // Set showList and URL fields based on cmp_type when editing
  useEffect(() => {
    if (isEditMode && editCampaignData?.cmp_type === "r") {
      setShowList(true);
      if (editCampaignData?.ctr_url) {
        const match = editCampaignData.ctr_url.match(/^(https?):\/\/(.*)/);
        if (match) {
          setUrlProtocol(match[1]);
          setUrlInput(match[2]);
        } else {
          setUrlInput(editCampaignData.ctr_url);
        }
      }
    }
  }, [isEditMode, editCampaignData?.cmp_type, editCampaignData?.ctr_url]);

  const fetchBrandProfiles = async () => {
    try {
      const res = await jobCampaignsService.getBrandProfiles();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ id, brand_name }) => ({
          value: id,
          label: brand_name,
        }));
        setBrandProfilesList(updatedPlatforms);

        // Auto-select if only one brand profile exists
        if (updatedPlatforms.length === 1 && !form.brand_profile_id) {
          updateForm({ brand_profile_id: updatedPlatforms[0].value });
        }
      }
    } catch (err) {
      console.log("🚀 ~ fetchBrandProfiles ~ err:", err);
    } finally {
    }
  };

  const fetchData = async () => {
    try {
      const res = await jobCampaignsService.getSocialMedia();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ code, name, ...rest }) => ({
          value: code,
          label: name,
          ...rest,
        }));
        setSociaMediaList(updatedPlatforms);
      }
    } catch (err) {
      console.log("🚀 ~ fetchData ~ err:", err);
      // addToast({
      //   error: true,
      //   msg: "Failed to load Data: " + (err.message || err),
      // });
    } finally {
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await jobCampaignsService.getCategories();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ id, name, ...rest }) => ({
          value: id,
          label: name,
          ...rest,
        }));
        setCategoriesList(updatedPlatforms);
      }
    } catch (err) {
      console.log("🚀 ~ fetchData ~ err:", err);
      // addToast({
      //   error: true,
      //   msg: "Failed to load Data: " + (err.message || err),
      // });
    } finally {
    }
  };

  const fetchCountries = async () => {
    try {
      const res = await jobCampaignsService.getCountry();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ id, name, ...rest }) => ({
          value: id,
          label: name,
          ...rest,
        }));
        setCountrytList(updatedPlatforms);
      }
    } catch (err) {
      console.log("🚀 ~ fetchData ~ err:", err);
    } finally {
    }
  };

  const validateBriefData = async () => {
    setIsError(!isError);

    // Validate required fields using the new structure
    console.log("🚀 ~ validateBriefData ~ form:", form);
    if (
      form.title === "" ||
      form.apply_by_date === "" ||
      form.scope_of_work === "" ||
      form.delivery_date === "" ||
      form.delivery_info === "" ||
      form.compensation === "" ||
      form.platform === "" ||
      form.category?.length === 0 ||
      form.reach_min === "" ||
      form.location === ""
    ) {
      setError(true);
      addToast({
        error: true,
        msg: isEditMode
          ? "Enter all details to update the campaign"
          : "Enter all details to save the campaign",
      });
      return;
    }

    // Validate delivery date is after apply date
    if (form.apply_by_date && form.delivery_date) {
      const applyDate = new Date(form.apply_by_date);
      const deliveryDate = new Date(form.delivery_date);

      if (deliveryDate <= applyDate) {
        setFieldErrors((prev) => ({
          ...prev,
          delivery_date: "Delivery date must be after apply date",
        }));
        setError(true);
        addToast({
          error: true,
          msg: "Delivery date must be after apply date",
        });
        return;
      }
    }

    setAllFieldsReadOnly();
    setError(false);
    try {
      // let param = {
      //   ...form,
      //   files: form.files || [],
      // };
      let param = {
        ...form,
        category: form.category?.map((cat) => cat.value) || [],
        cmp_type: showList ? "r" : "p",
        ctr_url: showList && urlInput ? `${urlProtocol}://${urlInput}` : "",
        files: (form.files || []).map((file) => {
          // Check if this is an already-saved backend file (has id or file_url)
          if (file?.id && file?.file_url) {
            return {
              file_size: file?.file_size,
              file_type: file?.file_type,
              original_file_name: file?.file_name || "",
              mediafile: file?.file_url, // main file link
              thumbnail_path: file?.thumbnail_path || file?.file_url, // fallback
              brand_profile_id: "56",
            };
          } else {
            // Already in correct format, just return as-is
            return file;
          }
        }),
      };
      console.log("🚀 ~ validateBriefData ~ param:", param);

      console.log("🚀 ~ validateBriefData ~ form:", form);

      // Use update or create based on edit mode
      const res =
        isEditMode && editCampaignData?.id
          ? await jobCampaignsService.updateCampaign(editCampaignData.id, param)
          : await jobCampaignsService.saveBrief(param);

      if (res && res.success === true) {
        setShowShareButton(true);
        addToast({
          error: false,
          msg:
            res.message ||
            (isEditMode
              ? "Campaign updated successfully"
              : "Brief saved successfully"),
        });

        // Refresh campaign data and redirect to main for both create and edit
        if (refreshCampaignData) {
          refreshCampaignData();
        }

        setTimeout(() => {
          setTab("main");
        }, 1500); // Wait 1.5 seconds to show the success message
      } else if (res && res.success === false) {
        setError(true);
        addToast({
          error: true,
          msg:
            res.message ||
            res.error ||
            (isEditMode ? "Failed to update campaign" : "Failed to save brief"),
        });
      } else {
        // Handle unexpected response format
        setError(true);
        addToast({
          error: true,
          msg: isEditMode
            ? "Failed to update campaign - unexpected response"
            : "Failed to save brief - unexpected response",
        });
      }
    } catch (err) {
      setError(true);
      addToast({
        error: true,
        msg:
          err.message ||
          (isEditMode ? "Error updating campaign" : "Error saving brief"),
      });
    }
  };

  return (
    <>
      <div
        style={{
          marginLeft: state === "collapsed" ? "28px" : "",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
          {/* Header Section */}
          <header 
            className="flex pb-4 flex-col md:flex-row md:items-center md:justify-between gap-3" 
            style={{ flexShrink: 0, zIndex: 20, position: "relative" }}
          >
            {/* Left Side - Back Button and Title */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate(-1)}
                className="flex h-[38px] px-5 justify-center items-center rounded-full text-sm font-medium cursor-pointer transition-all duration-200 bg-gray-50 text-gray-600 hover:bg-green-50 hover:text-green-700 border-none"
                style={{
                  boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.08)",
                }}
              >
                <ArrowLeft strokeWidth={2.2} size={18} className="mr-2" />
                Back
              </button>
              {/* <h2 className="text-xl font-bold text-gray-900">
                {isEditMode ? "Edit Campaign" : "Create Campaign"}
              </h2> */}
            </div>

            {/* Right Side - Public/Private Toggle */}
            <div 
              className="flex h-[38px] px-4 items-center gap-2 rounded-full"
              style={{
                background: showList ? "#F0FDF4" : "#F9FAFB",
                border: showList ? "1px solid #10B981" : "1px solid #E5E7EB",
                boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.08)",
              }}
            >
              <SwitchWithLabel
                id="listView"
                labelRight=""
                className="scale-75"
                checked={showList}
                onCheckedChange={() => setShowList(!showList)}
              />
              <div className="flex items-center gap-2">
                {!showList ? (
                  <span className="text-gray-500 font-medium text-sm">PUBLIC</span>
                ) : (
                  <>
                    <span className="text-green-700 font-medium text-sm">PRIVATE</span>
                    <Tooltip title="Private campaign" arrow placement="top">
                      <span
                        className="w-4 h-4 rounded-full bg-gray-300 flex items-center justify-center text-xs text-gray-600 font-medium cursor-help"
                      >
                        ?
                      </span>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          </header>

          {/* Main Content Container */}
          <div
            className="rounded-xl bg-white overflow-hidden w-full"
            style={{
              boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.08)",
              border: "1px solid rgba(16, 185, 129, 0.1)",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0,
            }}
          >
            <div
              className="p-6"
              style={{
                flex: 1,
                overflowY: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#e5e7eb transparent",
              }}
            >

        {/* Title and Hashtag Fields in one row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <BriefField
            key="title"
            config={fieldConfigs.find((config) => config.key === "title")}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
          <BriefField
            key="hashtag"
            config={fieldConfigs.find((config) => config.key === "hashtag")}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
        </div>
        {/* Apply By Date Field - Right aligned */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 mb-4">
          <div className="">
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1">
              {/* <svg
                className="w-5 h-5 text-green-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                  clipRule="evenodd"
                />
              </svg> */}
              Apply By Date
            </label>
            <div className="relative">
              <input
                onChange={setInput("apply_by_date")}
                value={form.apply_by_date || ""}
                type="date"
                min={getTodayDate()}
                className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 transition-colors cursor-pointer ${
                  !form.apply_by_date ? "text-gray-400" : "text-gray-900"
                }`}
                onClick={(e) => {
                  if (e.target.showPicker) {
                    e.target.showPicker();
                  } else {
                    e.target.focus();
                  }
                }}
              />
            </div>
          </div>
          <BriefField
            key="delivery_date"
            config={fieldConfigs.find(
              (config) => config.key === "delivery_date"
            )}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 mb-4">
          <div className="">
            <BriefField
              key="brand_profile_id"
              config={fieldConfigs.find(
                (config) => config.key === "brand_profile_id"
              )}
              form={form}
              error={error}
              showShareButton={showShareButton}
              setInput={setInput}
              fieldErrors={fieldErrors}
              handleUseAI={handleUseAI}
              isAILoading={isAILoading}
            />
          </div>
          <BriefField
            key="compensation"
            config={fieldConfigs.find(
              (config) => config.key === "compensation"
            )}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
        </div>

        {/* Qualification Section - 4 fields in a row */}

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-4">
          {/* Platform Field */}
          <div className="col-span-1">
            <BriefField
              key="platform"
              config={fieldConfigs.find((config) => config.key === "platform")}
              form={form}
              error={error}
              showShareButton={showShareButton}
              setInput={setInput}
              fieldErrors={fieldErrors}
              handleUseAI={handleUseAI}
              isAILoading={isAILoading}
            />
          </div>

          {/* Category Field */}
          <div className="col-span-1">
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-1">
              Category
              <span className="text-red-500">*</span>
            </label>
            <CategoryMultiSelect
              selectedOptions={form.category || []}
              onSelectedOptionsChange={(selected) =>
                updateForm({ category: selected })
              }
              multiSelectOptions={categoriesList || []}
            />
            {fieldErrors.category && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-2 mt-2">
                <div className="flex items-center gap-2">
                  <svg
                    className="w-4 h-4 text-red-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {fieldErrors.category}
                </div>
              </div>
            )}
          </div>

          {/* Reach Minimum Field */}
          <div className="col-span-1">
            <BriefField
              key="reach_min"
              config={fieldConfigs.find((config) => config.key === "reach_min")}
              form={form}
              error={error}
              showShareButton={showShareButton}
              setInput={setInput}
              fieldErrors={fieldErrors}
              handleUseAI={handleUseAI}
              isAILoading={isAILoading}
            />
          </div>

          {/* Location Field */}
          <div className="col-span-1">
            <BriefField
              key="location"
              config={fieldConfigs.find((config) => config.key === "location")}
              form={form}
              error={error}
              showShareButton={showShareButton}
              setInput={setInput}
              fieldErrors={fieldErrors}
              handleUseAI={handleUseAI}
              isAILoading={isAILoading}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 mb-3">
          <BriefField
            key="scope_of_work"
            config={fieldConfigs.find(
              (config) => config.key === "scope_of_work"
            )}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
          <BriefField
            key="delivery_info"
            config={fieldConfigs.find(
              (config) => config.key === "delivery_info"
            )}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
        </div>

        <div className="mb-4">
          <BriefField
            key="additional_info"
            config={fieldConfigs.find(
              (config) => config.key === "additional_info"
            )}
            form={form}
            error={error}
            showShareButton={showShareButton}
            setInput={setInput}
            fieldErrors={fieldErrors}
            handleUseAI={handleUseAI}
            isAILoading={isAILoading}
          />
        </div>

        <div className="">
          <div className="flex items-center gap-2 mb-2">
            <SwitchWithLabel
              id="listView"
              labelRight=""
              className="scale-90 "
              checked={showList}
              onCheckedChange={() => setShowList(!showList)}
            />
            {!showList && (
              <span className="text-sm font-medium text-gray-700">
                Click-Through Landing Page URL
              </span>
            )}
          </div>

          {showList && (
            <div>
              <label className=" font-medium text-sm text-gray-700 block mb-1">
                Enter landing page URL
              </label>
              <div className="flex gap-2">
                <select
                  value={urlProtocol}
                  onChange={(e) => setUrlProtocol(e.target.value)}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 bg-white text-gray-900"
                >
                  <option value="https">https://</option>
                  <option value="http">http://</option>
                </select>
                <input
                  type="text"
                  value={urlInput}
                  onChange={(e) => {
                    const value = e.target.value.replace(/^https?:\/\//, '');
                    setUrlInput(value);
                  }}
                  placeholder="example.com/campaign"
                  className="flex-1 p-3 border border-gray-300 rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 text-gray-900 placeholder-gray-400"
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Example: example.com/campaign or yourdomain.com/page
              </p>
              {/* <div className="relative w-full">
                <input
                  type="text"
                  value={form.ctr_url || ""}
                  onChange={(e) => updateForm({ ctr_url: e.target.value })}
                  placeholder="Enter Landing Page URL"
                  className="w-full text-gray-900 px-4 h-[48px] py-2 border border-gray-300 rounded-lg 
                         focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500
                         placeholder:text-gray-400 pr-24"
                /> */}
              {/* <span
                  className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center text-sm                  
                         px-3 py-1.5 rounded-lg cursor-pointer text-green-700 bg-green-50 hover:bg-green-100 border border-green-200 hover:border-green-300 transition-colors"
                >
                  Generate
                  <RefreshCw className="ml-1" size={14} />
                </span> */}
              {/* </div> */}
            </div>
          )}
        </div>

        {!showShareButton && (
          <div className="mt-4 mb-6">
            <div className="flex items-center ">
              {/* <svg
                className="w-5 h-5 text-green-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm0 2h12v10H4V5zm3 3a2 2 0 114 0 2 2 0 01-4 0zm9 7l-4-4-3 3-2-2-4 4h13z" />
              </svg> */}

              <h3 className="text-sm font-medium text-gray-700 mb-1">
                Media Assets
              </h3>
            </div>

            {/* File Upload Section */}
            <div className="space-y-4">
              <div className="relative">
                <input
                  type="file"
                  id="file-upload"
                  multiple
                  accept=".gif,.png,.jpg,.jpeg,.mp4,.mov,image/gif,image/png,image/jpeg,image/jpg,video/mp4,video/mov"
                  onChange={handleFileUpload}
                  disabled={isUploading}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="file-upload"
                  className={`group flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 rounded-lg hover:from-green-100 hover:to-emerald-100 focus:ring-1 focus:ring-green-500 focus:ring-offset-1 transition-all duration-200 font-medium border border-green-200 hover:border-green-300 shadow-sm hover:shadow-md cursor-pointer ${
                    isUploading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center group-hover:bg-green-600 transition-colors">
                    {isUploading ? (
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <Plus color="#ffffff" />
                    )}
                  </div>
                  <span>
                    {isUploading ? "Uploading..." : "Upload Files & Media"}
                  </span>
                </label>
              </div>

              {/* Upload Instructions */}
              {/* <div className="text-sm space-y-1">
                <p className="text-gray-400">
                  • Supported formats: .GIF, .PNG, .JPG, .MP4, .MOV
                </p>
                <p className="text-gray-400">
                  • Maximum file size: 10MB per file
                </p>
                <p className="text-gray-400">
                  • You can select multiple files at once
                </p>
              </div> */}

              {/* Uploaded Files List */}
              {newGalleryUploaded?.length > 0 && (
                <div className="mt-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <h4 className="text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Uploaded Files ({newGalleryUploaded?.length})
                  </h4>
                  <div
                    className="space-y-2 max-h-40 overflow-y-auto"
                    style={{
                      scrollbarWidth: "thin",
                      scrollbarColor: "#e5e7eb transparent",
                    }}
                  >
                    {newGalleryUploaded?.map((file, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-2 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
                      >
                        <div className="flex items-center gap-3 flex-1 min-w-0">
                          <div className="flex-shrink-0">
                            {file.media_type_id === 1 ||
                            ["png", "jpg", "jpeg", "gif"].includes(
                              file.file_type.toLowerCase()
                            ) ? (
                              // Image thumbnail
                              <img
                                src={file.mediafile || file.file_url}
                                alt={file.mediafile || file.file_url}
                                className="w-10 h-10 object-cover rounded-lg border border-gray-200"
                                // onError={(e) => {
                                //   e.target.style.display = "none";
                                //   e.target.nextSibling.style.display = "block";
                                // }}
                              />
                            ) : (
                              <div className="w-10 h-10 bg-purple-100 rounded-lg border border-gray-200 flex items-center justify-center">
                                <svg
                                  className="w-6 h-6 text-purple-500"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
                                </svg>
                              </div>
                            )}
                            {/* Fallback icon (hidden by default) */}
                            {/* <div
                              className="w-12 h-12 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center"
                              style={{ display: "none" }}
                            >
                              <svg
                                className="w-6 h-6 text-gray-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div> */}
                          </div>
                          <span
                            className="text-sm text-gray-700 truncate"
                            title={
                              file.original_file_name ||
                              file.filename ||
                              `File ${index + 1}`
                            }
                          >
                            {file.original_file_name ||
                              file.filename ||
                              `File ${index + 1}`}
                          </span>
                        </div>
                        <button
                          onClick={() => {
                            setIndexForAction(index);
                            setShowConfirmDelete(true);
                          }}
                          className="flex-shrink-0 p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                          title="Delete file"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
                              clipRule="evenodd"
                            />
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Upload Error */}
              {uploadError && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  <div className="flex items-center gap-2">
                    <svg
                      className="w-4 h-4 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{uploadError}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-end items-center gap-4 mt-6 pt-6 border-t border-gray-100">
                <button
                  className="flex h-[42px] px-6 items-center gap-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 bg-gray-50 text-gray-600 hover:bg-gray-100 border-none"
                  style={{
                    boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.08)",
                  }}
                  onClick={() => setTab("main")}
                >
                  <ArrowLeft strokeWidth={2.2} size={16} />
                  Back to Campaigns
                </button>

                {!showShareButton ? (
                  <button
                    className="flex h-[42px] px-6 items-center gap-2 rounded-full text-sm font-semibold cursor-pointer border-none text-white transition-all duration-200 hover:opacity-90"
                    style={{
                      background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
                      boxShadow: "0px 2px 6px 0px rgba(16, 185, 129, 0.25)",
                    }}
                    onClick={validateBriefData}
                  >
                    {isEditMode ? "Update Campaign" : "Save Campaign"}
                  </button>
                ) : (
                  <button 
                    className="flex h-[42px] px-6 items-center gap-2 rounded-full text-sm font-semibold cursor-pointer border-none text-white transition-all duration-200 hover:opacity-90"
                    style={{
                      background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
                      boxShadow: "0px 2px 6px 0px rgba(16, 185, 129, 0.25)",
                    }}
                  >
                    Share Campaign
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showConfirmDelete && (
        <Modal close={() => setShowConfirmDelete(false)} className="right-20">
          <div className="p-6 max-w-md mx-auto bg-white rounded-lg shadow-lg">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <svg
                  className="h-6 w-6 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.314 15.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Delete Media
              </h3>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to delete this media? This action cannot
                be undone.
              </p>
              <div className="flex justify-center gap-3">
                <button
                  type="button"
                  className="px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:ring-1 focus:ring-gray-500 focus:ring-offset-1 transition-colors font-medium"
                  onClick={() => setShowConfirmDelete(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-1 transition-colors font-medium"
                  onClick={() => removeItem(indexForAction)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {toastList && (
        <Toast type="rate" list={toastList} setList={setToastList} />
      )}
    </>
  );
}
